import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FilterMemoryPort } from '@festo-ax/smartenance-shared-ui';
import { GlobalFilterMemoryStore } from './global-filter-memory.store';

export function provideFilterMemory(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: FilterMemoryPort,
      useExisting: GlobalFilterMemoryStore,
    },
  ]);
}
